import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import {
  searchPage,
  container,
  body,
  ctaContainer,
  cta,
} from './styles.module.css';

/**
 * Event search recommend race presentational component.
 */
const EventRecommendRaceCardSearch = ({ isSearchPage, className, href }) => {
  const isSearchPageClass = isSearchPage ? [searchPage] : [];
  return (
    <div className={[container, className].concat(isSearchPageClass).join(' ')}>
      <div className={[body].concat(isSearchPageClass).join(' ')}>
        <div>
          <p>
            <strong>{"Can't find an event?"}</strong>
          </p>
          <p>
            {"Let us know the name and we'll add it as fast as possible."}
            <br />
            {"We're talking Usain Bolt fast."}
          </p>
        </div>
        <div className={[ctaContainer].concat(isSearchPageClass).join(' ')}>
          {href ? (
            <a
              href="https://letsdothisuk.typeform.com/to/ZdtYHJ"
              className={[cta].concat(isSearchPageClass).join(' ')}
              target="_blank"
            >
              <strong>{'Recommend event'}</strong>
            </a>
          ) : (
            <Link
              to="https://letsdothisuk.typeform.com/to/ZdtYHJ"
              className={[cta].concat(isSearchPageClass).join(' ')}
              target="_blank"
            >
              <strong>{'Recommend event'}</strong>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

EventRecommendRaceCardSearch.propTypes = {
  /**
   * CSS class name to be added to the container
   */
  className: PropTypes.string,
  /**
   * Whether this component is being displayed as part of search results,
   * as opposed to the name search banner
   */
  isSearchPage: PropTypes.bool,
};

EventRecommendRaceCardSearch.defaultProps = {
  className: null,
  isSearchPage: false,
};

export default EventRecommendRaceCardSearch;
